(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@cornerstonejs/core"), require("gl-matrix"));
	else if(typeof define === 'function' && define.amd)
		define(["@cornerstonejs/core", "gl-matrix"], factory);
	else if(typeof exports === 'object')
		exports["cornerstoneStreamingImageVolumeLoader"] = factory(require("@cornerstonejs/core"), require("gl-matrix"));
	else
		root["cornerstoneStreamingImageVolumeLoader"] = factory(root["cornerstone3D"], root["window"]);
})(self, (__WEBPACK_EXTERNAL_MODULE__953__, __WEBPACK_EXTERNAL_MODULE__976__) => {
return 